import React from "react";
import { Button } from "semantic-ui-react";
import { PermissionCheck } from "components/auth";
import { Targets, Actions } from "constants/Permissions";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { addDocumentType } from "./actions";
import DocumentTypeForm from "./DocumentTypeForm";

const AddDocumentType = ({ as: As = Button, onAdded, ...props }) => (
  <ModalBuilder
    withForm
    submitAction={addDocumentType}
    onSubmitted={onAdded}
    renderTrigger={(showModal) => (
      <PermissionCheck target={Targets.DocumentType} action={Actions.Create}>
        <As onClick={showModal} {...props} />
      </PermissionCheck>
    )}
    renderModal={(modalProps, formProps) => (
      <Modal.Add {...modalProps} header="Add Document Type">
        <DocumentTypeForm {...formProps} />
      </Modal.Add>
    )}
  />
);

export default AddDocumentType;
